import script from "./InformationWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationWrapper.vue?vue&type=script&setup=true&lang=js"

import "./InformationWrapper.vue?vue&type=style&index=0&id=fd9c7eae&lang=scss"

const __exports__ = script;

export default __exports__